import { LOGGING_POST_INFO_SUCCESS } from '../constants/log';

const initState = {
  logInfo: {},
};

const log = (state = initState, action = {}) => {
  switch (action.type) {
    case LOGGING_POST_INFO_SUCCESS:
      return { ...state, logInfo: action.logInfo };
    default:
      return state;
  }
};

export default log;
